/**
 * SearchIcon/index.js
 * desc: search icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const SearchIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="search icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.search.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M11.71 11h.79l4.99 5L16 17.49l-5-4.99v-.79l-.27-.28A6.471 6.471 0 016.5 13 6.5 6.5 0 1113 6.5c0 1.61-.59 3.09-1.57 4.23l.28.27zM2 6.5C2 8.99 4.01 11 6.5 11S11 8.99 11 6.5 8.99 2 6.5 2 2 4.01 2 6.5z"/></svg>
    </IconButton>
);



export default SearchIcon;
